
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, watch, watchEffect } from 'vue'
import LeftTree from '@/components/asktheSecretary/lefttree.vue'
import Content from '@/components/asktheSecretary/content.vue'
import Search from '@/components/asktheSecretary/inputSelect.vue'
import Top10 from '@/components/asktheSecretary/top10.vue'
import { askApi } from '@/api/index'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store/index'
import { mapState, mapMutations, mapActions } from 'vuex'
import optionalshares from '@/components/optionalshares.vue'
import globalsets from '@/utils/globalsets'
import axsios from 'axios'
import ws from '../../websocket/index'
export default defineComponent({
  components: {
    LeftTree,
    Content,
    Search,
    optionalshares,
    Top10
  },
  setup(props, context) {
    const topsearch: any = ref()
    const pageData: any = reactive({
      token: '',
      navObj: {},
      storeObj: {},
      searchObj: {},
      // 热门概念
      sectorExt: [],
      // 热门概念对象
      sectorExtObj: {},
      websock: null,
      // 概念、互动、关键词top10
      initInfoSecretaryTopData: {},
      AQContent: []
    })
    const route: any = useRoute()
    const content = ref()
    const theme = route.query.theme || 'light'

    async function gettoken() {
      if (route.query.market && route.query.code) {
        pageData.token = await globalsets.getToken()
      } else {
        pageData.token = await globalsets.getToken()
      }
    }

    /**
     * 如果点击了左侧导航，则清空搜索框的条件
     * 如果改变了keywortds，则改写navObj
     */
    //
    // 如果
    function clickNav(item: any) {
      pageData.navObj = item
    }
    function changeKeywords(obj: any) {
      // 中间问答区的查询条件
      // pageData.storeObj = obj
    }
    function changeObj(obj: any) {
      // 问答区查询的相关所有数据，比storeObj 参数多一点
      const _obj = JSON.parse(JSON.stringify(obj))
      let data = {}
      if ((obj.InstExt || []).length) {
        data = obj.InstExt[0]
      } else if ((obj.KeyWords || []).length) {
        data = obj.KeyWords[0]
      }
      // 此时修改navObj
      /**
       *Exch: "AHZBSECTOR"
        Inst: "GN011424"
        Name: "储能"
        Num: 217
        isNew: false
        time: 1648806115
        timer: 33
        type: "gn"
       */
      // pageData.navObj = {
      //   type: 'search',
      //   ...data
      // }
      pageData.searchObj = JSON.parse(JSON.stringify(obj))
      pageData.storeObj = {
        InstExt: (_obj.InstExt || []).map((item: any) => ({ Exch: item.MarketCode, Inst: item.Code })),
        KeyWords: pageData.searchObj.KeyWords
      }
      // pageData.storeObj.InstExt = (_obj.InstExt || []).map((item: any) => ({ Exch: item.MarketCode, Inst: item.Code }))
      // pageData.storeObj.KeyWords = pageData.searchObj.KeyWords
      // 需要调接口去查询
      nextTick(() => {
        if ((obj.InstExt || []).length || (obj.KeyWords || []).length) {
          content.value.onSearch(false)
        }
      })
    }
    function clickHotKeywords(obj: any) {
      pageData.storeObj = {
        KeyWords: [obj.Name],
        type: 'hotKeywords'
      }
      // pageData.searchObj.KeyWords = [obj.Name]
      // 需要调接口去查询
      nextTick(() => {
        content.value.onSearch(false)
      })
    }
    gettoken()
    // 如果query里有市场和代码
    onMounted(() => {
      if(route.query.code&&route.query.market){
        ws.websocket.safeSubscribeDYNA(route.query.code,route.query.market)
        ws.websocket.on('onMessage', msg => {
          const _data = msg.QuoteData
        if (_data && _data.StaticData && _data.StaticData[0]) {
          pageData.navObj = {
            type: 'gp',
            Market: route.query.market,
            Symbol: route.query.code,
            Name: _data.StaticData[0].InstrumentName
          }
          console.log('打印数据===',_data.StaticData[0].InstrumentName)
        }
        })

      }
    })
    function clearsearch() {
      pageData.navObj = {
        type: 'all'
      }
      nextTick(() => {
        content.value.onSearch(false)
      })
    }
    function initInfoSecretaryTop(obj: any) {
      pageData.initInfoSecretaryTopData = obj
    }
    function getAQContent(val: any) {
      pageData.AQContent = val
    }
    return {
      ...toRefs(pageData),
      theme,
      clickNav,
      changeKeywords,
      content,
      changeObj,
      clickHotKeywords,
      topsearch,
      clearsearch,
      initInfoSecretaryTop,
      getAQContent
    }
  }
})
